import {gql} from '@apollo/client';
import {ACT_GROUP, TASK} from '../../graphql/fragments';

export const PULL_ACT_GROUP = gql`
  mutation PullActGroup {
    pullActivityGroups(agName: "CS Task List") {
      ok
    }
  }
`;

export const GET_ACTIVITY_GROUPS = gql`
  ${ACT_GROUP}
  query OneviewGroups {
    oneviewGroups {
      ...ActivityGroup
    }
  }
`;

export const LIST_TASKS = gql`
  ${TASK}
  query ListTasks($accountId: UUID, $reviewId: UUID) {
    tasks(accountId: $accountId, reviewId: $reviewId) {
      ...Task
    }
  }
`;

export const CREATE_TASK = gql`
  ${TASK}
  mutation CreateTask(
    $regardingId: UUID!
    $activityGroupId: UUID
    $activitySubGroupId: UUID
    $contactId: UUID
    $dueDate: DateTime
    $isActivityReport: Boolean
    $isWaiting: Boolean
    $description: String
    $subject: String
    $activityStatus: TaskActivityStatusEnum
    $priority: TaskPriorityEnum
    $urgency: TaskUrgencyEnum
    $statusReason: TaskStatusReasonEnum
    $percentComplete: Int
    $regardingEntity: TaskRegardingEntityEnum
    $selectedEntityType: TaskRegardingEntityEnum
    $selectedEntityId: UUID
  ) {
    createTask(
      regardingId: $regardingId
      regardingEntity: $regardingEntity
      activityGroupId: $activityGroupId
      activitySubGroupId: $activitySubGroupId
      contactId: $contactId
      dueDate: $dueDate
      isActivityReport: $isActivityReport
      isWaiting: $isWaiting
      description: $description
      subject: $subject
      activityStatus: $activityStatus
      priority: $priority
      urgency: $urgency
      statusReason: $statusReason
      percentComplete: $percentComplete
      selectedEntityType: $selectedEntityType
      selectedEntityId: $selectedEntityId
    ) {
      ok
      errors
      task {
        ...Task
      }
    }
  }
`;

export const UPDATE_TASK = gql`
  ${TASK}
  mutation UpdateTask(
    $taskId: UUID!
    $activityGroupId: UUID
    $activitySubGroupId: UUID
    $contactId: UUID
    $dueDate: DateTime
    $isActivityReport: Boolean
    $isWaiting: Boolean
    $description: String
    $subject: String
    $activityStatus: TaskActivityStatusEnum
    $priority: TaskPriorityEnum
    $urgency: TaskUrgencyEnum
    $statusReason: TaskStatusReasonEnum
    $percentComplete: Int
    $regardingEntity: TaskRegardingEntityEnum
    $clearContact: Boolean
    $regardingId: UUID!
    $selectedEntityType: TaskRegardingEntityEnum
    $selectedEntityId: UUID
  ) {
    updateTask(
      taskId: $taskId
      regardingEntity: $regardingEntity
      activityGroupId: $activityGroupId
      activitySubGroupId: $activitySubGroupId
      contactId: $contactId
      dueDate: $dueDate
      isActivityReport: $isActivityReport
      isWaiting: $isWaiting
      description: $description
      subject: $subject
      activityStatus: $activityStatus
      priority: $priority
      urgency: $urgency
      statusReason: $statusReason
      percentComplete: $percentComplete
      regardingId: $regardingId
      clearContact: $clearContact
      selectedEntityType: $selectedEntityType
      selectedEntityId: $selectedEntityId
    ) {
      ok
      task {
        ...Task
      }
      errors
    }
  }
`;

export const SUBMIT_TASK = gql`
  ${TASK}
  mutation SubmitTask($taskId: UUID!) {
    submitTask(taskId: $taskId) {
      ok
      task {
        ...Task
      }
      errors
    }
  }
`;

export const DELETE_TASK = gql`
  mutation DeleteTask($taskId: UUID!) {
    deleteTask(taskId: $taskId) {
      ok
      taskId
    }
  }
`;
